var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasAuth)?_c('div',{style:('display: '+ _vm.displayType +';')},[_vm._t("default")],2):(_vm.elseInfo)?_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v(_vm._s(_vm.elseInfo))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }